import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import trimLevels from '../../graphql/queries/trimLevels';
import { GetTrimLevels, GetTrimLevelsVariables } from '../../graphql/queries/__generated__/GetTrimLevels';
import useErrorHandler from '../../../gqlCommon/hooks/useErrorHandler';
import IParams from '../../../gqlCustomise/model/IParams';

const useTrimLevelsQuery = () => {
  const { trimCode } = useParams<IParams>();
  const { data, loading, error } = useQuery<GetTrimLevels, GetTrimLevelsVariables>(trimLevels.GET_TRIM_LEVELS, {
    variables: { trimCode: decodeURIComponent(trimCode) },
  });

  useErrorHandler(error);

  return { data, loading, error };
};

export default useTrimLevelsQuery;
